module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_06.a55134e0.png";